// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "850" ? "monaco-editor" : chunkId) + "." + {"361": "87071941","41": "7fb2b051","669": "c1d3883d","672": "a2301851","850": "e56fa031",}[chunkId] + ".css"
}